import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ComponentColumn } from '../../../../../../app/entities';

@Component({
  selector: 'app-shovel-view-column-sortpopup',
  templateUrl: './shovel-view-column-sortpopup.component.html',
  styleUrls: ['./shovel-view-column-sortpopup.component.scss']
})
export class ShovelViewColumnSortpopupComponent implements OnInit {
  componentColumns: ComponentColumn[] = [];
  @Output() columnOrderChanged = new EventEmitter<ComponentColumn[]>();
  constructor(
    public dialogRef: MatDialogRef<ShovelViewColumnSortpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.componentColumns = this.data.columns;
  }
  get sortedComponentColumns(): ComponentColumn[] {
    return this.componentColumns;
  }
  onCloseClick(): void {
    this.dialogRef.close(this.componentColumns);
  }
  moveUp(column: ComponentColumn): void {
    const index = this.componentColumns.indexOf(column);
    if (index <= 0) {
      return;
    }
    [
      this.componentColumns[index - 1],
      this.componentColumns[index]
    ] = [
        this.componentColumns[index],
        this.componentColumns[index - 1]
      ];

    this.componentColumns.forEach((x, i) => x.order = i + 1);
     this.data.onChanged();
  }

  moveDown(column: ComponentColumn): void {

    const index = this.componentColumns.indexOf(column);

    if (index >= this.componentColumns.length - 1) {
      return;
    }

    [
      this.componentColumns[index + 1],
      this.componentColumns[index]
    ] = [
        this.componentColumns[index],
        this.componentColumns[index + 1]
      ];

    this.componentColumns.forEach((x, i) => x.order = i + 1);
     this.data.onChanged();
  }
  toggleColumn(column: ComponentColumn): void {
    //column.visible = !column.visible;
    this.data.onChanged();
  }
}
